export default __webpack_public_path__ + "medium_high_coverage_ses_bc.png";